/* Aus snippets/search-drawer.liquid ausgelagert (vorher Inline-Skript in jeder Seite) */
						(function () {
							var box = document.querySelector('[data-s4t-lazy-products]');
							if (!box) return;
							var started = false;
							/* Scroll-Anzeige unter der wischbaren Produktreihe (Handy): Balken
							   zeigt, wie viel noch seitlich kommt. Ohne Ueberlauf ausgeblendet. */
							function addBar(list) {
								var bar = document.createElement('div');
								bar.className = 's4t-promo-bar';
								bar.setAttribute('aria-hidden', 'true');
								var thumb = document.createElement('span');
								bar.appendChild(thumb);
								list.parentNode.insertBefore(bar, list.nextSibling);
								function update() {
									var sw = list.scrollWidth, cw = list.clientWidth;
									if (!cw || sw <= cw + 2) { bar.hidden = true; return; }
									bar.hidden = false;
									var size = cw / sw;
									var pos = list.scrollLeft / (sw - cw);
									thumb.style.width = (size * 100) + '%';
									thumb.style.left = (pos * (1 - size) * 100) + '%';
								}
								list.addEventListener('scroll', update, { passive: true });
								window.addEventListener('resize', update);
								document.addEventListener('search:open', function () { setTimeout(update, 50); });
								update();
								setTimeout(update, 300);
							}
							function load() {
								if (started) return;
								started = true;
								var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
								fetch(root + '?section_id=search-promo-products')
									.then(function (r) { return r.ok ? r.text() : ''; })
									.then(function (html) {
										var doc = new DOMParser().parseFromString(html, 'text/html');
										var list = doc.querySelector('.products');
										if (list) { box.appendChild(list); box.style.minHeight = ''; addBar(list); }
										else { started = false; }
									})
									.catch(function () { started = false; });
							}
							document.addEventListener('search:open', load);
							document.querySelectorAll('.thb-quick-search').forEach(function (el) {
								el.addEventListener('pointerenter', load, { once: true });
								el.addEventListener('touchstart', load, { once: true, passive: true });
								el.addEventListener('click', load);
							});
							var input = document.querySelector('#Search-Drawer input[type="search"]');
							if (input) input.addEventListener('focus', load, { once: true });
						})();
					
